export enum DocumentationKanbanStatus {
    Default = 'Ni pripravljeno',
    Prepared = 'Pripravljeno',
    Signed = 'Podpisano',
    Shared = 'Poslano',
}
